import { useAeropayUser } from '@iheartjane/data-access/react-query';
import { useMoengageIdentify as useIdentifyToMoengage } from '@iheartjane/tracking';
import Moe from '@moengage/web-sdk';
import { useCallback, useMemo } from 'react';

import { getJwt } from '@jane/shared/auth';
import { useJaneUser } from '@jane/shared/data-access';
import { Storage, getJaneDeviceId } from '@jane/shared/util';

import type { MoeEvent } from './moengageEvents.types';

export const useMoengage = () => {
  const { data: janeUser } = useJaneUser();
  const { data: aeropayUser } = useAeropayUser({
    janeUserId: janeUser?.user?.id ?? null,
    jwt: getJwt(),
  });
  const janeDeviceId = getJaneDeviceId();
  const linkedAccountDate = Storage.get('aeropayLinkDate') || null;

  const commonData = useMemo(
    () => ({
      'Aeropay Account Verified': !!aeropayUser?.bank_accounts.length,
      'Aeropay Link Date': linkedAccountDate,
      'Jane Device Id': janeDeviceId,
      'User Id': janeUser?.user?.id,
    }),
    [aeropayUser, janeUser?.user]
  );

  const moeTrack = useCallback(
    (event: MoeEvent) => {
      if (Moe.isMoeLoaded()) {
        Moe.track_event(event.name, {
          Time: new Date(),
          ...commonData,
          ...event.properties,
        });
      }
    },
    [commonData]
  );

  return { moeTrack };
};

export const useMoengageIdentify = () => {
  const { data: janeUser } = useJaneUser();

  useIdentifyToMoengage(janeUser?.user);
};
